export default function authMultipartHeader (token) {
  if (token) {
    return { Authorization: 'Bearer ' + token, accept: '*/*', 'Content-Type': 'multipart/form-data' }
  } else {
    return {}
  }
}
